module.exports = __webpack_public_path__ + "static/media/laboral.137e3ff3.svg";